import React, { useRef, useEffect } from "react"
import styled from "styled-components"
import ArrowPrev from "../../images/icons/arrow-prev.png"
import ArrowNext from "../../images/icons/arrow-next.png"
import { Swiper } from "swiper"

const SwiperContainer = styled.div`
  margin-top: 50px;

  .swiper-slide {
    width: auto;
  }

  .swiper-wrapper {
    /* transition-timing-function: ease-out !important;
    transition-duration: 300ms !important; */
  }
`

const Arrows = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: var(--gutter-s);
`

const ArrowContainer = styled.div`
  margin-bottom: var(--gutter-l);
`

const ArrowInfo = styled.p`
  justify-content: center;
  text-transform: uppercase;
  text-align: center;
  margin-right: var(--gutter-m);
  margin-left: var(--gutter-m);
  font-size: 12px;
  font-weight: 600;
`

const Arrow = styled.div`
  img {
    width: 15px;
  }

  &.swiper-button-prev {
    margin-right: var(--gutter-m);
  }

  &.swiper-button-disabled {
    opacity: 0.3;
  }
`

type Props = {
  children: React.ReactNode
  singleSlide?: boolean
}

const ImageSliderWrapper: React.FC<Props> = ({
  children,
  singleSlide = false,
}: Props) => {
  const swiperContainerRef = useRef<any>()
  const swiperRef = useRef<any>()
  const prevArrowRef = useRef<any>()
  const nextArrowRef = useRef<any>()

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      swiperRef.current = new Swiper(swiperContainerRef.current, {
        centeredSlides: singleSlide ? true : false,
        spaceBetween: singleSlide ? 0 : 50,
        slidesPerView: "auto",
        freeMode: true,
        freeModeMomentumVelocityRatio: 1,
        freeModeMomentumRatio: 0.8,
        speed: 200,
        slidesPerGroup: 1,
        slidesOffsetBefore: singleSlide ? 0 : 20,
        slidesOffsetAfter: singleSlide ? 0 : 20,
        breakpoints: {
          992: {
            slidesOffsetBefore: singleSlide ? 0 : 40,
            slidesOffsetAfter: singleSlide ? 0 : 40,
          },
        },
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
      })
      swiperRef.current.slideTo(0)
    }, 700)

    return (): void => {
      window.clearTimeout(timeout)
    }
  }, [])

  return (
    <SwiperContainer>
      {!singleSlide ? (
        <ArrowContainer>
          <Arrows>
            <Arrow className="swiper-button-prev" ref={prevArrowRef}>
              <img src={ArrowPrev} />
            </Arrow>
            <Arrow className="swiper-button-next" ref={nextArrowRef}>
              <img src={ArrowNext} />
            </Arrow>
          </Arrows>
          <ArrowInfo>
            {" "}
            Swipe left or right <br /> to view more images{" "}
          </ArrowInfo>
        </ArrowContainer>
      ) : null}
      <div ref={swiperContainerRef}>
        <div className="swiper-wrapper">{children}</div>
      </div>
    </SwiperContainer>
  )
}

export default ImageSliderWrapper
